import { useState } from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import { Box, Button, TextField, Grid } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

interface EntityInfoEditProps {
  onSubmit: () => void;
  entityId: string;
  entityName: string;
  description: string;
  email: string;
}
export const EntityInfoEdit = ({
  onSubmit, entityId, description, entityName, email
}: EntityInfoEditProps) => {
  const api = useApi();
  const [newDescription, setNewDescription] = useState<string>(description);
  const [emails, setEmails] = useState<string>(email);

  const entityEditDescription = useMutation(api.editEntityDescriptionApiV1EditEntityDescriptionPost, {
    onSuccess() {
      toast.success('Updated Entity description successfully.');
      onSubmit();
    },
    onError: apiError,
  });

  const handleSubmit = () => {
    entityEditDescription.mutate({
      entity_id: entityId,
      description: newDescription,
      email: emails,
    });
  };

  return (
    <Box pt={2}>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6}>
          <TextField
            sx={{ mb: 4 }}
            fullWidth
            label="Entity ID"
            variant="outlined"
            defaultValue={entityId}
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            sx={{ mb: 4 }}
            fullWidth
            label="Entity Name"
            variant="outlined"
            defaultValue={entityName}
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            sx={{ mb: 4 }}
            fullWidth
            label="Description"
            variant="outlined"
            value={newDescription}
            onChange={(e) => setNewDescription(e.target.value)}
            autoFocus
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            sx={{ mb: 4 }}
            fullWidth
            label="Event Notification Emails"
            variant="outlined"
            value={emails}
            onChange={(e) => setEmails(e.target.value)}
          />
        </Grid>
      </Grid>
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit} disabled={newDescription === ''}>
          Save
        </Button>
      </Box>
    </Box>
  );
};
